export const stateToStatus = (state) => {
  switch (state) {
    case 'online':
      return 'Running';
    case 'stopped':
      return 'Stopped';
    default:
      return 'Unknown';
  }
};

export const getStatusFromAction = (action) => {
  switch (action) {
    case 'start':
      return 'Running';
    case 'stop':
      return 'Stopped';
    case 'restart':
      return 'Restarting';
    default:
      return 'Unknown';
  }
};

export const formatBytes = (value) => {
  if (typeof value !== 'number') return 'N/A';
  return `${(value / (1024 * 1024)).toFixed(2)}MB`;
};

const formatDuration = (ms) => {
  if (!ms || typeof ms !== 'number') return 'N/A';

  const totalSeconds = Math.floor(ms / 1000); // strip milliseconds
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
};

const formatUptime = (startTimestampMs) => {
  if (!startTimestampMs || typeof startTimestampMs !== 'number') return 'N/A';

  const now = Date.now();
  const diff = now - startTimestampMs; // uptime in ms
  if (diff < 0) return 'N/A'; // tour
  return formatDuration(diff);
};

export const mapServiceRecord = (service = {}) => ({
  id: service.pm_id,
  name: service.name,
  status: stateToStatus(service.state),
  uptime: formatUptime(service.uptime),
  created: 'N/A',
  restartCount: service.restarts ?? 0,
  unstableRestart: service.unstable_restarts ?? 0,
  cpu: service.cpu ?? 0,
  memory: formatBytes(service.memory),
});

export const canBeModified = (service = {}) => {
  const name = service?.name || '';
  const isSystem =
    name.includes('FusionBackend') ||
    name.includes('EventService') ||
    name.includes('SupervisorService');
  return !isSystem;
};
